export const CAMPAIGN = {
    STOP_CAMPAIGN: 'STOP_CAMPAIGN',
    STOP_CAMPAIGN_FAILED: 'STOP_CAMPAIGN_FAILED',
    STOP_CAMPAIGN_SUCCESS: 'STOP_CAMPAIGN_SUCCESS'
}

export const stopCampaign = payload => ({
    type: CAMPAIGN.STOP_CAMPAIGN,
    payload
})